import { render } from "./LoginForgotPassword.vue?vue&type=template&id=bfbfb4c2&scoped=true"
import script from "./LoginForgotPassword.vue?vue&type=script&lang=js"
export * from "./LoginForgotPassword.vue?vue&type=script&lang=js"

import "./LoginForgotPassword.vue?vue&type=style&index=0&id=bfbfb4c2&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbfb4c2"]])

export default __exports__